const GAP_PX = 8

const positionPreview = (option) => {
  const preview = option.querySelector(".backoffice-mailer-header-picker__preview")
  if (!preview) return

  const rect = option.getBoundingClientRect()
  preview.style.left = `${rect.left + rect.width / 2}px`
  preview.style.bottom = `${window.innerHeight - rect.top + GAP_PX}px`
  preview.style.top = "auto"
}

const clearPreview = (option) => {
  option.classList.remove("is-previewing")
}

const bindMailerHeaderOption = (option) => {
  if (option.dataset.previewBound === "true") return
  option.dataset.previewBound = "true"

  option.addEventListener("pointerenter", () => {
    if (option.classList.contains("is-preview-suppressed")) return
    positionPreview(option)
    option.classList.add("is-previewing")
  })

  option.addEventListener("pointerleave", () => {
    clearPreview(option)
    option.classList.remove("is-preview-suppressed")
  })

  option.addEventListener("click", () => {
    option.classList.add("is-preview-suppressed")
    clearPreview(option)
  })
}

const initBackofficeMailerHeaderPicker = () => {
  document
    .querySelectorAll(".backoffice-mailer-header-picker__option")
    .forEach(bindMailerHeaderOption)
}

document.addEventListener("scroll", () => {
  document.querySelectorAll(".backoffice-mailer-header-picker__option.is-previewing").forEach((option) => {
    positionPreview(option)
  })
}, true)

document.addEventListener("turbolinks:before-cache", () => {
  document.querySelectorAll(".backoffice-mailer-header-picker__option").forEach((option) => {
    clearPreview(option)
    option.classList.remove("is-preview-suppressed")
    option.dataset.previewBound = "false"
  })
})

export { initBackofficeMailerHeaderPicker }
